<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12 md12 sm12>
            <v-layout row wrap>
                <v-flex lg4 md12 sm12 pr-6 pl-lg-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuStart"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedStartDateFormatted"
                                label="Từ ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 md12 sm12 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuEnd"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedEndDateFormatted"
                                label="Đến ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 md12 sm12 pr-6>
                    <v-btn @click="filter_data" color="#a77800" outlined>Xem</v-btn>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex lg12 v-if="buyer_summary">
            <h4>Doanh số nhân viên mua hàng</h4>
            <v-data-table :headers="buyer_headers" :items="buyer_summary" :options.sync="pagination" :server-items-length="buyer_summary ? buyer_summary.length : 0" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>{{ item.BuyerID | display_value(staffs, 'ID', 'FullName') }}</td>
                        <td class="text-end">{{ item.AmountCNY | currency('',2)}}</td>
                        <td class="text-end">{{ item.AmountVND | currency}}</td>
                        <td class="text-end">{{ item.TotalRealAmountCNY | currency('',2)}}</td>
                        <td class="text-end">{{ item.RealAmountRevenueCNY | currency('',2)}}</td>
                        <td class="text-end">{{ item.RealAmountRevenue | currency}}</td>
                    </tr>
                </template>
                </v-data-table>
        </v-flex>
        <v-flex lg12 v-if="cs_summary">
          <h4>Doanh số nhân viên CSKH</h4>
            <v-data-table :headers="cs_headers" :items="cs_summary" :options.sync="pagination" :server-items-length="cs_summary ? cs_summary.length : 0" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>{{ item.CustomerServiceID | display_value(staffs, 'ID', 'FullName') }}</td>
                        <td class="text-end">{{ item.FeeBuyAmount | currency}}</td>
                        <td class="text-end">{{ item.FeeWeightAmount | currency}}</td>
                        <td class="text-end">{{ item.AmountCNY | currency('',2)}}</td>
                        <td class="text-end">{{ item.AmountVND | currency}}</td>
                        <td class="text-end">{{ item.TotalRealAmountCNY | currency('',2)}}</td>
                        <td class="text-end">{{ item.RealAmountRevenueCNY | currency('',2)}}</td>
                        <td class="text-end">{{ item.RealAmountRevenue | currency}}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        <v-flex lg12 v-if="sale_summary">
          <h4>Doanh số nhân viên sale</h4>
            <v-data-table :headers="sale_headers" :items="sale_summary" :options.sync="pagination" :server-items-length="sale_summary ? sale_summary.length : 0" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>{{ item.SalerID | display_value(staffs, 'ID', 'FullName') }}</td>
                        <td>{{ item.ReportType | display_value(report_types)}}</td>
                        <td class="text-end">{{ item.FeeBuyAmount | currency}}</td>
                        <td class="text-end">{{ item.AmountCNY | currency('',2)}}</td>
                        <td class="text-end">{{ item.AmountVND | currency}}</td>
                        <td class="text-end">{{ item.TotalRealAmountCNY | currency('',2)}}</td>
                        <td class="text-end">{{ item.RealAmountRevenueCNY | currency('',2)}}</td>
                        <td class="text-end">{{ item.RealAmountRevenue | currency}}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import moment from "moment";
export default {
  data() {
    return {
      buyer_headers: [
        {
          text: "Nhân viên",
          value: "BuyerID",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Tiền hàng (¥)",
          value: "AmountCNY",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Tiền hàng (đ)",
          value: "AmountVND",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Mua thật (¥)",
          value: "TotalRealAmountCNY",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Chênh lệch (¥)",
          value: "RealAmountRevenueCNY",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Chênh lệch",
          value: "RealAmountRevenue",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        }
      ],
      cs_headers: [
        {
          text: "Nhân viên",
          value: "CustomerServiceID",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí dịch vụ",
          value: "FeeBuyAmount",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí cân nặng",
          value: "FeeWeightAmount",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Tiền hàng (¥)",
          value: "AmountCNY",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Tiền hàng (đ)",
          value: "AmountVND",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Mua thật (¥)",
          value: "TotalRealAmountCNY",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Chênh lệch (¥)",
          value: "RealAmountRevenueCNY",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Chênh lệch",
          value: "RealAmountRevenue",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        }
      ],
      sale_headers: [
        {
          text: "Nhân viên",
          value: "SalerID",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Mốc doanh số",
          value: "ReportType",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí dịch vụ",
          value: "FeeBuyAmount",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Tiền hàng (¥)",
          value: "AmountVND",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Tiền hàng (đ)",
          value: "AmountCNY",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Mua thật (¥)",
          value: "TotalRealAmountCNY",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Chênh lệch (¥)",
          value: "RealAmountRevenueCNY",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Chênh lệch",
          value: "RealAmountRevenue",
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        }
      ],
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      filterConditions: [],
      quickFilterConditions: [],
      viewName: "thong-ke-hoa-hong-nhan-vien",
      dateRange: {
        startDate: moment
          .utc(Date.now())
          .startOf("month")
          .toISOString()
          .substr(0, 10),
        endDate: moment
          .utc(Date.now())
          .endOf("month")
          .toISOString()
          .substr(0, 10)
      },
      menuStart: false,
      menuEnd: false,
      order_type_list: configs.ORDER_TYPE_LIST,
      report_types: [{value: 1, name: '0 - 60 days'},{value: 2, name: '61 - 240 days'},{value: 3, name: '241 days ~'}]
    };
  },
  watch: {
    pagination: {
        handler: function (val, oldVal) {
            let filterConditions = this.$store.state.commons.filterConditions;
            this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
            this.filter_data();
        },
        deep: true
    },
  },
  computed: {
    ...mapState({
      buyer_summary: state => state.report.commissionReport.data.buyer_summary,
      cs_summary: state => state.report.commissionReport.data.cs_summary,
      sale_summary: state => state.report.commissionReport.data.sale_summary,
      staffs: state => state.commons.all_users,
      loading: state => state.report.loading
    }),
    computedStartDateFormatted() {
      return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
    },
    computedEndDateFormatted() {
      return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    }
  },
  methods: {
    filter_data: _.debounce(function () {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions,
        startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
        endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
      };
      this.$store.dispatch("report/getCommissionReport", param);
    }, 300, {
        'leading': true,
        'trailing': false
    }),
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    }
  },
  mounted() {
    this.filter_data();
    this.$store.dispatch("commons/getAllUsers");
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>